import { AxiosResponse } from "axios"

export const responseInterceptorSuccessCredentials = async (
  response: AxiosResponse
) => {
  return response
}

export const responseInterceptorErrorCredentials = async (error: any) => {
  if (error.response.status === 403) {
  } else {
  }
  return Promise.reject(error)
}
